module.exports = __webpack_public_path__ + "img/安全产品示例图_4.61d90e35.png";